<template>
  <div
    v-if="statusConfig"
    :class="statusConfig.containerClass"
    class="flex items-start gap-1 w-fit rounded-md border border-solid px-2 py-1"
  >
    <v-icon :color="statusConfig.iconColor" size="small" :icon="statusConfig.icon"></v-icon>
    <span class="text-sm font-medium" :class="statusConfig.textColor">
      {{ statusConfig.label }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { mdiLockOpenVariant, mdiLock } from '@mdi/js'
import { VIcon } from 'vuetify/components'
import { ExceptionSummaryStatus } from '@/Network/Types/Responses/StationResponses'

const props = defineProps<{
  status: ExceptionSummaryStatus | null | undefined
}>()

const statusConfig = computed(() => {
  if (!props.status) return null

  switch (props.status) {
    case ExceptionSummaryStatus.APPROVED:
      return {
        label: 'Excepcionalidade aprovada',
        icon: mdiLockOpenVariant,
        iconColor: '#DA1E28',
        textColor: 'text-[#16161D]',
        containerClass: 'bg-[#FCE9EA] border-[#DA1E28]'
      }
    case ExceptionSummaryStatus.IN_PROGRESS:
      return {
        label: 'Excepcionalidade em andamento',
        icon: mdiLock,
        iconColor: '#F18F1B',
        textColor: 'text-[#16161D]',
        containerClass: 'bg-[#FEF3E7] border-[#F18F1B]'
      }
    case ExceptionSummaryStatus.IN_REVIEW:
      return {
        label: 'Excepcionalidade em revisão',
        icon: mdiLockOpenVariant,
        iconColor: '#F1C21B',
        textColor: 'text-[#16161D]',
        containerClass: 'bg-[#FEF9E7] border-[#F1C21B]'
      }
    default:
      return null
  }
})
</script>
